import React, { useEffect, useState, useRef } from "react";
import {
  Container,
  Risk,
  Risks,
  Images,
  Image,
  Setor,
  RiskItem,
} from "./styles";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { useAuth } from "../../../hooks/AuthContext";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { MdAdd, MdDelete, MdEdit, MdSearch } from "react-icons/md";
import { AutoComplete, Button, Input, Modal, Select, Spin } from "antd";
import InputMask from "react-input-mask";
import { risks as allRisks } from "../../../services/states";
import { Message, ViewInput } from "../../../GlobalStyles";
import Status from "../../../components/status";

const { confirm } = Modal;

function validateCPF(cpf) {
  if (!cpf) return false;
  const cleanCPF = String(cpf).replace(/\D/g, "");
  if (cleanCPF.length !== 11) return false;
  if (/^(\d)\1+$/.test(cleanCPF)) return false;
  let add = 0;
  for (let i = 0; i < 9; i++) add += parseInt(cleanCPF.charAt(i)) * (10 - i);
  let rev = 11 - (add % 11);
  if (rev === 10 || rev === 11) rev = 0;
  if (rev !== parseInt(cleanCPF.charAt(9))) return false;
  add = 0;
  for (let i = 0; i < 10; i++) add += parseInt(cleanCPF.charAt(i)) * (11 - i);
  rev = 11 - (add % 11);
  if (rev === 10 || rev === 11) rev = 0;
  if (rev !== parseInt(cleanCPF.charAt(10))) return false;
  return true;
}

function validateCNPJ(cnpj) {
  if (!cnpj) return false;
  const b = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const c = String(cnpj).replace(/[^\d]/g, "");

  if (c.length !== 14) return false;
  if (/^(\d)\1+$/.test(c)) return false;

  let n = 0;
  for (let i = 0; i < 12; i++) {
    n += parseInt(c[i]) * b[i + 1];
  }
  if (parseInt(c[12]) !== ((n %= 11) < 2 ? 0 : 11 - n)) return false;

  n = 0;
  for (let i = 0; i <= 12; i++) {
    n += parseInt(c[i]) * b[i];
  }
  if (parseInt(c[13]) !== ((n %= 11) < 2 ? 0 : 11 - n)) return false;

  return true;
}

function formatCPF(cpf) {
  if (!cpf) return "";
  const clean = String(cpf).replace(/\D/g, "");
  if (clean.length !== 11) return cpf;
  return clean.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
}

function formatCNPJ(cnpj) {
  if (!cnpj) return "";
  const clean = String(cnpj).replace(/\D/g, "");
  if (clean.length !== 14) return cnpj;
  return clean.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
}

function formatCAEPF(caepf) {
  if (!caepf) return "";
  const clean = String(caepf).replace(/\D/g, "");
  if (clean.length !== 14) return caepf;
  return clean.replace(/(\d{3})(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3/$4-$5");
}

function formatPhone(phone) {
  if (!phone) return "";
  const clean = String(phone).replace(/\D/g, "");
  if (clean.length === 10) {
    return clean.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
  } else if (clean.length === 11) {
    return clean.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
  }
  return phone;
}

export default function EditCompany() {
  const { user } = useAuth();
  const { company_id } = useParams();

  const [id, setId] = useState("");
  const [company, setCompany] = useState(null);
  const [companySector, setCompanySector] = useState([
    {
      name: "",
      description: "",
      companyScratchs: [],
      companyEmployees: [
        {
          name: "",
          epis: "",
          quantidade_colaboradores: 0,
          description: "",
          quantidade_colaboradores_m: 0,
          quantidade_colaboradores_f: 0,
          cbo: "",
        },
      ],
    },
  ]);

  const [name, setName] = useState("");
  const [doc, setDoc] = useState("");
  const [companyImages, setCompanyImages] = useState([[]]);
  const [loading, setLoading] = useState(true);
  const [razao_social, setRazao_social] = useState("");
  const [nome_fantasia, setNome_Fantasia] = useState("");
  const [cnpj, setCnpj] = useState("");
  const [type, setType] = useState("CNPJ");
  const [ramo_atividade, setRamo_atividade] = useState("");
  const [endereco, setEndereco] = useState("");
  const [cep, setCep] = useState("");
  const [nome_responsavel, setNome_responsavel] = useState("");
  const [cpf_responsavel, setCpf_responsavel] = useState("");
  const [contato_responsavel, setContato_responsavel] = useState("");
  const [message, setMessage] = useState("");
  const [observation, setObservation] = useState("");
  const [visibleModal, setVisibleModal] = useState(false);
  const [visibleModalRisk, setVisibleModalRisk] = useState(false);
  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const [id_risk, setId_risk] = useState("");
  const [id_sector, setId_sector] = useState("");
  const [name_risk, setName_risk] = useState("");
  const [type_risk, setType_risk] = useState("");
  const [description_risk, setDescription_risk] = useState("");
  const [fonte_geradora, setFonte_geradora] = useState("");
  const [perigos, setPerigos] = useState("");
  const [avaliacao_risco, setAvaliacao_risco] = useState("");
  const [probabilidade, setProbabilidade] = useState("");
  const [efeito, setEfeito] = useState("");
  const [epis, setEpis] = useState("");
  const [epcs, setEpcs] = useState("");
  const [optionsRisks, setOptionsRisks] = useState([]);
  const [errors, setErrors] = useState({});
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [deleteEmploye, setDeleteEmploye] = useState([]);
  const [deleteSector, setDeleteSector] = useState([]);
  const isLoaded = useRef(false);

  const [copyModalVisible, setCopyModalVisible] = useState(false);
  const [companiesToCopy, setCompaniesToCopy] = useState([]);
  const [selectedCompanyToCopy, setSelectedCompanyToCopy] = useState(null);
  const [loadingCopy, setLoadingCopy] = useState(false);

  async function loadCompaniesToCopy(search = "") {
    setLoadingCopy(true);
    let url = `/companies`;
    if (search) {
      url += `?search=${search}`;
    }
    await api
      .get(url)
      .then((response) => {
        setCompaniesToCopy(response.data.companies || []);
      })
      .catch(() => {
        toast.error("Erro ao buscar empresas para copiar");
      });
    setLoadingCopy(false);
  }

  function openCopyModal() {
    setCopyModalVisible(true);
    setSelectedCompanyToCopy(null);
    loadCompaniesToCopy("");
  }

  async function handleConfirmCopy() {
    if (!selectedCompanyToCopy) {
      toast.warn("Selecione uma empresa para copiar");
      return;
    }
    setLoading(true);
    setCopyModalVisible(false);
    await api
      .get(`/company/${selectedCompanyToCopy}`)
      .then((response) => {
        const copiedCompany = response.data;
        const oldSectorIds = companySector.map((s) => s.id).filter(Boolean);
        const oldEmployeeIds = companySector.reduce((ids, s) => {
          if (s.companyEmployees) {
            const empIds = s.companyEmployees.map((e) => e.id).filter(Boolean);
            return [...ids, ...empIds];
          }
          return ids;
        }, []);

        setDeleteSector((prev) => [...prev, ...oldSectorIds]);
        setDeleteEmploye((prev) => [...prev, ...oldEmployeeIds]);

        if (copiedCompany.razao_social) {
          setRazao_social(copiedCompany.razao_social);
        } else {
          setRazao_social("");
        }
        if (copiedCompany.nome_fantasia) {
          setNome_Fantasia(copiedCompany.nome_fantasia);
        } else {
          setNome_Fantasia("");
        }
        const companyType = copiedCompany.type || "CNPJ";
        setType(companyType);
        if (copiedCompany.cnpj) {
          const cleanCnpj = copiedCompany.cnpj.replace(/\D/g, "");
          if (companyType === "CNPJ") {
            setCnpj(formatCNPJ(cleanCnpj));
          } else {
            setCnpj(formatCAEPF(cleanCnpj));
          }
        } else {
          setCnpj("");
        }
        if (copiedCompany.ramo_atividade) {
          setRamo_atividade(copiedCompany.ramo_atividade);
        } else {
          setRamo_atividade("");
        }
        if (copiedCompany.observation) {
          setObservation(copiedCompany.observation);
        } else {
          setObservation("");
        }
        if (copiedCompany.cep) {
          setCep(copiedCompany.cep.replace(/\D/g, ""));
        } else {
          setCep("");
        }
        if (copiedCompany.endereco) {
          setEndereco(copiedCompany.endereco);
        } else {
          setEndereco("");
        }
        if (copiedCompany.nome_responsavel) {
          setNome_responsavel(copiedCompany.nome_responsavel);
        } else {
          setNome_responsavel("");
        }
        if (copiedCompany.cpf_responsavel) {
          setCpf_responsavel(formatCPF(copiedCompany.cpf_responsavel));
        } else {
          setCpf_responsavel("");
        }
        if (copiedCompany.contato_responsavel) {
          setContato_responsavel(
            copiedCompany.contato_responsavel.replace(/\D/g, ""),
          );
        } else {
          setContato_responsavel("");
        }

        let sectors = [];
        if (copiedCompany.companySector) {
          sectors = copiedCompany.companySector.map((sector) => {
            console.log(sector);
            const cleanedSector = {
              name: sector.name || "",
              description: sector.description || "",
              sgg_id: sector.sgg_id || "",
              sgg_risks_id: sector.sgg_risks_id || "",
            };

            if (sector.companyEmployees) {
              cleanedSector.companyEmployees = sector.companyEmployees.map(
                (emp) => {
                  return {
                    name: emp.name || "",
                    epis: emp.epis || "",
                    quantidade_colaboradores: emp.quantidade_colaboradores || 0,
                    description: emp.description || "",
                    quantidade_colaboradores_m:
                      emp.quantidade_colaboradores_m || 0,
                    quantidade_colaboradores_f:
                      emp.quantidade_colaboradores_f || 0,
                    cbo: emp.cbo || "",
                    sgg_id: emp.sgg_id || "",
                  };
                },
              );
            } else {
              cleanedSector.companyEmployees = [
                {
                  name: "",
                  epis: "",
                  quantidade_colaboradores: 0,
                  description: "",
                  quantidade_colaboradores_m: 0,
                  quantidade_colaboradores_f: 0,
                  cbo: "",
                },
              ];
            }

            if (sector.companyScratchs) {
              cleanedSector.companyScratchs = sector.companyScratchs.map(
                (risk) => {
                  return {
                    name: risk.name || "",
                    type: risk.type || "",
                    description: risk.description || "",
                    fonte_geradora: risk.fonte_geradora || "",
                    perigos: risk.perigos || "",
                    efeito: risk.efeito || "",
                    probabilidade: risk.probabilidade || "",
                    epis: risk.epis || "",
                    epcs: risk.epcs || "",
                    medidas_controle: risk.medidas_controle || "",
                    tempo_exposicao: risk.tempo_exposicao || "",
                    tipo_exposicao: risk.tipo_exposicao || "",
                  };
                },
              );
            } else {
              cleanedSector.companyScratchs = [];
            }

            return cleanedSector;
          });
        }

        if (sectors.length === 0) {
          setCompanySector([
            {
              name: "",
              description: "",
              companyScratchs: [],
              companyEmployees: [
                {
                  name: "",
                  epis: "",
                  quantidade_colaboradores: 0,
                  description: "",
                  quantidade_colaboradores_m: 0,
                  quantidade_colaboradores_f: 0,
                  cbo: "",
                },
              ],
            },
          ]);
        } else {
          console.log(sectors);
          setCompanySector(sectors);
        }

        setCompanyImages([[]]);

        toast.success("Formulário copiado com sucesso!");
      })
      .catch(({ response }) => {
        if (response && response.data && response.data.message) {
          toast.error(response.data.message);
        } else {
          toast.error("Erro ao copiar os dados do formulário");
        }
      });
    setLoading(false);
  }

  useEffect(() => {
    if (loading) return;
    if (!isLoaded.current) {
      isLoaded.current = true;
      return;
    }
    setHasUnsavedChanges(true);
  }, [
    razao_social,
    nome_fantasia,
    cnpj,
    type,
    ramo_atividade,
    endereco,
    cep,
    nome_responsavel,
    cpf_responsavel,
    contato_responsavel,
    companySector,
  ]);

  useEffect(() => {
    if (type_risk) {
      const normalizedType = type_risk
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();
      setOptionsRisks(
        allRisks
          .filter((item) => {
            const itemTypeNormalized = item.tipo
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .toLowerCase();
            // Handle "Acidente" vs "Acidentes"
            if (
              normalizedType === "acidente" ||
              normalizedType === "acidentes"
            ) {
              return (
                itemTypeNormalized === "acidente" ||
                itemTypeNormalized === "acidentes"
              );
            }
            return itemTypeNormalized === normalizedType;
          })
          .map((item) => {
            return {
              label: item.agente,
              value: item.agente,
            };
          }),
      );
    } else {
      setOptionsRisks([]);
    }
  }, [type_risk]);
  const [medidas_controle, setMedidas_controle] = useState("");
  const [tempo_exposicao, setTempo_exposicao] = useState("");
  const [tipo_exposicao, setTipo_exposicao] = useState("");
  const [isLoadingIA, setIsLoadingIA] = useState("");
  const [total, setTotal] = useState(0);
  const [totalM, setTotalM] = useState(0);
  const [status, setStatus] = useState("");

  useEffect(() => {
    loadingCompany();
  }, []);

  useEffect(() => {
    getFuncionarios();
  }, [companySector]);

  async function loadingCompany() {
    setLoading(true);
    await api
      .get(`/company/${company_id}`)
      .then((response) => {
        const company = response.data;
        setCompany(company);
        setStatus(company.status);
        setId(company.id);
        if (company.status == "confirmado" || company.status == "expirado") {
          setMessage("Este formulário já foi preenchido");
        }
        if (company.razao_social) {
          setRazao_social(company.razao_social);
        }
        if (company.nome_fantasia) {
          setNome_Fantasia(company.nome_fantasia);
        }
        const companyType = company.type || "CNPJ";
        if (company.type) {
          setType(company.type);
        }
        if (company.cnpj) {
          const cleanCnpj = company.cnpj.replace(/\D/g, "");
          if (companyType === "CNPJ") {
            setCnpj(formatCNPJ(cleanCnpj));
          } else {
            setCnpj(formatCAEPF(cleanCnpj));
          }
        }
        if (company.ramo_atividade) {
          setRamo_atividade(company.ramo_atividade);
        }
        if (company.observation) {
          setObservation(company.observation);
        }
        if (company.cep) {
          setCep(company.cep.replace(/\D/g, ""));
        }
        if (company.endereco) {
          setEndereco(company.endereco);
        }
        if (company.nome_responsavel) {
          setNome_responsavel(company.nome_responsavel);
        }
        if (company.cpf_responsavel) {
          setCpf_responsavel(formatCPF(company.cpf_responsavel));
        }
        if (company.contato_responsavel) {
          setContato_responsavel(
            company.contato_responsavel.replace(/\D/g, ""),
          );
        }
        if (company.companySector.length == 0) {
          setCompanySector([
            {
              name: "",
              description: "",
              companyScratchs: [],
              companyEmployees: [
                {
                  name: "",
                  epis: "",
                  quantidade_colaboradores: 0,
                  description: "",
                  quantidade_colaboradores_m: 0,
                  quantidade_colaboradores_f: 0,
                  cbo: "",
                },
              ],
            },
          ]);
        } else {
          let sectores = [...company.companySector];
          sectores.map((item) => {
            if (item.companyEmployees.length == 0) {
              item.companyEmployees = [
                {
                  name: "",
                  epis: "",
                  quantidade_colaboradores: 0,
                  description: "",
                  quantidade_colaboradores_m: 0,
                  quantidade_colaboradores_f: 0,
                  cbo: "",
                },
              ];
            }
          });
          setCompanySector(sectores);
          setCompanyImages(company.companyImages);
        }
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              setMessage(response.data.message);
            } else {
              setMessage(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            setMessage("Erro Interno. verifique sua conexão e tente novamente");
          }
        } else {
          setMessage("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setLoading(false);
  }

  async function verifyCompany(confirm) {
    let newErrors = {};
    let error = "";

    if (!razao_social) {
      newErrors.razao_social = true;
      error = "Preencha a Razão Social/Nome";
    }
    if (!cnpj) {
      newErrors.cnpj = true;
      if (!error) error = `Preencha o ${type}`;
    } else if (type === "CNPJ" && !validateCNPJ(cnpj)) {
      newErrors.cnpj = true;
      if (!error) error = "CNPJ inválido";
    } else if (type === "CAEPF" && cnpj.replace(/\D/g, "").length !== 14) {
      newErrors.cnpj = true;
      if (!error) error = "CAEPF inválido";
    }
    if (!ramo_atividade) {
      newErrors.ramo_atividade = true;
      if (!error) error = "Preencha o Ramo de Atividade";
    }
    if (!cep) {
      newErrors.cep = true;
      if (!error) error = "Preencha o CEP";
    }
    if (!endereco) {
      newErrors.endereco = true;
      if (!error) error = "Preencha o Endereço";
    }
    const isCAEPF = String(type).toUpperCase() === "CAEPF";
    if (isCAEPF) {
      if (!nome_responsavel) {
        newErrors.nome_responsavel = true;
        if (!error) error = "Preencha o Nome do Responsável";
      }
      if (!cpf_responsavel) {
        newErrors.cpf_responsavel = true;
        if (!error) error = "Preencha o CPF do Responsável";
      } else if (!validateCPF(cpf_responsavel)) {
        newErrors.cpf_responsavel = true;
        if (!error) error = "CPF do Responsável inválido";
      }
      if (!contato_responsavel) {
        newErrors.contato_responsavel = true;
        if (!error) error = "Preencha o Contato do Responsável";
      }
    } else {
      if (cpf_responsavel && !validateCPF(cpf_responsavel)) {
        newErrors.cpf_responsavel = true;
        if (!error) error = "CPF do Responsável inválido";
      }
    }

    const sectorNames = companySector.map((item) => (item.name || "").trim().toLowerCase()).filter(Boolean);
    const uniqueSectorNames = new Set(sectorNames);
    if (sectorNames.length !== uniqueSectorNames.size) {
      if (!error) error = "Não é permitido salvar o formulário com setores que possuem nomes iguais.";
    }

    if (confirm && companySector.length === 0) {
      if (!error) error = "Para confirmar, o formulário deve possuir pelo menos um setor.";
    }

    let sectorErrors = [];
    companySector.forEach((item, index) => {
      let currentSectorError = { employees: [], scratchs: [] };
      let hasSectorError = false;

      if (confirm) {
        if (!item.companyEmployees || item.companyEmployees.length === 0) {
          hasSectorError = true;
          if (!error) error = `O setor "${item.name || `Setor ${index + 1}`}" deve possuir pelo menos uma função para confirmar o formulário.`;
        }
        if (!item.companyScratchs || item.companyScratchs.length === 0) {
          hasSectorError = true;
          if (!error) error = `O setor "${item.name || `Setor ${index + 1}`}" deve possuir pelo menos um risco para confirmar o formulário.`;
        }
      }

      if (!item.name) {
        currentSectorError.name = true;
        hasSectorError = true;
        if (!error) error = `Preencha o nome do setor ${index + 1}`;
      }
      if (!item.description) {
        currentSectorError.description = true;
        hasSectorError = true;
        if (!error) error = `Preencha a descrição do setor ${index + 1}`;
      }

      item.companyEmployees.forEach((data, i) => {
        let employeeError = {};
        let hasEmpError = false;
        if (!data.name) {
          employeeError.name = true;
          hasEmpError = true;
        }
        if (!data.description) {
          employeeError.description = true;
          hasEmpError = true;
        }
        if (!data.epis) {
          employeeError.epis = true;
          hasEmpError = true;
        }
        if (!data.cbo) {
          employeeError.cbo = true;
          hasEmpError = true;
        }
        if (!data.quantidade_colaboradores) {
          employeeError.quantidade_colaboradores = true;
          hasEmpError = true;
        }

        if (hasEmpError) {
          currentSectorError.employees[i] = employeeError;
          hasSectorError = true;
          if (!error) {
            error = `Preencha todos os campos da função ${i + 1} no setor ${index + 1}`;
          }
        }
      });

      item.companyScratchs.forEach((risk, riskIndex) => {
        let riskError = {};
        let hasRiskError = false;
        if (!risk.name) {
          riskError.name = true;
          hasRiskError = true;
        }
        if (!risk.type) {
          riskError.type = true;
          hasRiskError = true;
        }
        if (!risk.description) {
          riskError.description = true;
          hasRiskError = true;
        }
        if (!risk.fonte_geradora) {
          riskError.fonte_geradora = true;
          hasRiskError = true;
        }
        if (!risk.perigos) {
          riskError.perigos = true;
          hasRiskError = true;
        }
        if (!risk.probabilidade) {
          riskError.probabilidade = true;
          hasRiskError = true;
        }
        if (!risk.efeito) {
          riskError.efeito = true;
          hasRiskError = true;
        }
        if (!risk.epis) {
          riskError.epis = true;
          hasRiskError = true;
        }
        if (!risk.epcs) {
          riskError.epcs = true;
          hasRiskError = true;
        }
        if (!risk.tipo_exposicao) {
          riskError.tipo_exposicao = true;
          hasRiskError = true;
        }
        if (!risk.tempo_exposicao) {
          riskError.tempo_exposicao = true;
          hasRiskError = true;
        }

        if (hasRiskError) {
          currentSectorError.scratchs[riskIndex] = riskError;
          hasSectorError = true;
          if (!error) {
            error = `O risco "${risk.name || "Sem nome"}" no setor "${item.name || `Setor ${index + 1}`}" está incompleto.`;
          }
        }
      });

      if (hasSectorError) {
        sectorErrors[index] = currentSectorError;
      }
    });

    newErrors.sectors = sectorErrors;
    setErrors(newErrors);

    if (error) {
      toast.warn(error);
    } else {
      if (user.id == company.collaborador_id) {
        if (confirm) {
          if (hasUnsavedChanges) {
            toast.warn(
              "Você possui alterações não salvas. Por favor, clique em 'Salvar' antes de finalizar o formulário.",
            );
            return;
          }
          confirmCompany();
        } else {
          editCompany();
        }
      } else {
        if (confirm) {
          toast.warn("Apenas o responsável pelo formulário pode confirmar");
        } else {
          editCompany();
        }
      }
    }
  }

  async function getRisks(idxSector) {
    setIsLoadingIA(`S${idxSector}`);
    await api
      .get(
        `/ia/risks?sector=${companySector[idxSector].name}${
          companySector[idxSector].name
            ? `&description=${companySector[idxSector].description}`
            : ""
        }&occupations=${companySector[idxSector].companyEmployees
          .map((item) => item.name)
          .join(", ")}`,
      )
      .then((response) => {
        const companySectorEdit = [...companySector];
        companySectorEdit[idxSector].companyScratchs = response.data;
        setCompanySector(companySectorEdit);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.warn(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.warn("Erro Interno. verifique sua conexão e tente novamente");
          }
        } else {
          toast.warn("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setIsLoadingIA("");
  }

  async function getRisksImages(idxSector) {
    setIsLoadingIA(`SI${idxSector}`);
    await api
      .get(
        `/ia/risks/images?images=${companyImages[idxSector]
          .map((item) => item.photo_url)
          .join(",")}`,
      )
      .then((response) => {
        const companySectorEdit = [...companySector];
        companySectorEdit[idxSector].companyScratchs = response.data;
        console.log(companySectorEdit);
        setCompanySector(companySectorEdit);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.warn(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.warn("Erro Interno. verifique sua conexão e tente novamente");
          }
        } else {
          toast.warn("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setIsLoadingIA("");
  }

  async function getRisk(type, name, idxSector) {
    setIsLoadingIA(`R`);
    await api
      .get(
        `/ia/risk?name=${name}&type=${type}&sector=${companySector[idxSector].name}`,
      )
      .then((response) => {
        const risk = response.data;
        if (name_risk) {
          setDescription_risk(risk.description);
          setFonte_geradora(risk.fonte_geradora);
          setEpis(risk.epis);
          setEpcs(risk.epcs);
          setMedidas_controle(risk.medidas_controle);
          setTipo_exposicao(risk.tipo_exposicao);
          setTempo_exposicao(risk.tempo_exposicao);
          setPerigos(risk.perigos);
          setProbabilidade(risk.probabilidade);
          setEfeito(risk.efeito);
        }
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.warn(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.warn("Erro Interno. verifique sua conexão e tente novamente");
          }
        } else {
          toast.warn("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setIsLoadingIA("");
  }

  async function getOccupation(idxSector, idxOccupation, occupation) {
    setIsLoadingIA(`S${idxSector}F${idxOccupation}`);
    if (!occupation) {
      toast.warn("Preencha a função para o autopreenchimento");
    } else {
      await api
        .get(`/ia/occupation?name=${occupation}`)
        .then((response) => {
          const companySectorEdit = [...companySector];
          companySectorEdit[idxSector].companyEmployees[
            idxOccupation
          ].description = response.data.description;
          companySectorEdit[idxSector].companyEmployees[idxOccupation].epis =
            response.data.epis;
          companySectorEdit[idxSector].companyEmployees[idxOccupation].name =
            response.data.name;
          companySectorEdit[idxSector].companyEmployees[idxOccupation].cbo =
            response.data.cbo;
          console.log(companySectorEdit);
          setCompanySector(companySectorEdit);
        })
        .catch(({ response }) => {
          if (response) {
            if (response.data) {
              if (response.data.message) {
                toast.warn(response.data.message);
              } else {
                toast.warn(
                  "Erro Interno. verifique sua conexão e tente novamente",
                );
              }
            } else {
              toast.warn(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.warn("Erro Interno. verifique sua conexão e tente novamente");
          }
        });
    }
    setIsLoadingIA("");
  }

  async function lookupCNPJ() {
    if (cnpj.replace(/\D/g, "").length === 14) {
      setIsLoadingIA("CNPJ");
      await api
        .get(`https://brasilapi.com.br/api/cnpj/v1/${cnpj.replace(/\D/g, "")}`)
        .then((response) => {
          const data = response.data;
          setRazao_social(data.razao_social);
          setNome_Fantasia(data.nome_fantasia || data.razao_social);
          setRamo_atividade(data.cnae_fiscal_descricao);
          setEndereco(
            `${data.logradouro}, ${data.numero}${
              data.complemento ? ` - ${data.complemento}` : ""
            } - ${data.bairro}, ${data.municipio} - ${data.uf}`,
          );
          setCep(data.cep);
        })
        .catch(() => {
          toast.error(
            "Erro ao buscar CNPJ. Verifique se o número está correto.",
          );
        });
      setIsLoadingIA("");
    } else {
      toast.warn("Digite um CNPJ válido para buscar.");
    }
  }

  async function editCompany() {
    await api
      .put(`/company/${company_id}`, {
        razao_social: razao_social,
        nome_fantasia: nome_fantasia,
        cnpj: cnpj,
        ramo_atividade: ramo_atividade,
        cep: cep,
        endereco: endereco,
        nome_responsavel: nome_responsavel,
        cpf_responsavel: cpf_responsavel,
        contato_responsavel: formatPhone(contato_responsavel),
        companySector: companySector,
        type: type,
        deleteEmploye: deleteEmploye,
        deleteSector: deleteSector,
      })
      .then(() => {
        loadingCompany();
        toast.success("Formulário editado com sucesso");
        setHasUnsavedChanges(false);
        setErrors({});
        setDeleteEmploye([]);
        setDeleteSector([]);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  async function confirmCompany() {
    await api
      .put(`/confirm-company/${company_id}`)
      .then(() => {
        setMessage("Formulário confirmado com sucesso");
        setStatus("confirmado");
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  function deleteFuncao(indexSetor, indexFuncao) {
    let companySectorC = [...companySector];
    const employee = companySectorC[indexSetor].companyEmployees[indexFuncao];
    if (employee && employee.id) {
      setDeleteEmploye((prev) => [...prev, employee.id]);
    }
    companySectorC[indexSetor].companyEmployees = companySectorC[
      indexSetor
    ].companyEmployees.filter((_, idx) => idx !== indexFuncao);
    setCompanySector(companySectorC);
    setHasUnsavedChanges(true);
    toast.success("Função excluída com sucesso");
  }

  function deleteSetor(indexSetor) {
    const sector = companySector[indexSetor];
    if (sector && sector.id) {
      setDeleteSector((prev) => [...prev, sector.id]);
    }
    let companySectorC = companySector.filter(
      (_, index) => index !== indexSetor,
    );
    let companyImagesC = companyImages.filter(
      (_, index) => index !== indexSetor,
    );

    setCompanySector(companySectorC);
    setCompanyImages(companyImagesC);
    setHasUnsavedChanges(true);
    toast.success("Setor excluído com sucesso");
  }

  function getFuncionarios() {
    let total = 0;
    let totalM = 0;
    companySector.map((item) => {
      item.companyEmployees.map((data) => {
        total += parseInt(data.quantidade_colaboradores) || 0;
        totalM += parseInt(data.quantidade_colaboradores_m) || 0;
      });
    });
    setTotal(total);
    setTotalM(totalM);
  }

  return (
    <div
      style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      <Container>
        {loading ? (
          <div
            style={{ display: "flex", width: "100%", justifyContent: "center" }}
          >
            <Spin
              size="large"
              style={{
                marginTop: 50,
              }}
            />
          </div>
        ) : (
          <>
            {message ? (
              <Message
                style={{
                  height: "80px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {message}
              </Message>
            ) : (
              <>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                    flexWrap: "wrap",
                    gap: "10px",
                    marginBottom: "15px",
                  }}
                >
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <h1 style={{ margin: 0 }}>
                      {status == "alteracao" ? "Alteração" : "Cadastro"} de
                      Formulário
                    </h1>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        margin: "5px 0 0 12px",
                      }}
                    >
                      <Status status={status} />
                    </div>
                  </div>
                  {status === "aguardando" && (
                    <Button
                      type="primary"
                      onClick={() => {
                        openCopyModal();
                      }}
                      style={{
                        height: "36px",
                        borderRadius: "6px",
                        fontWeight: "600",
                      }}
                    >
                      COPIAR FORMULÁRIO
                    </Button>
                  )}
                </div>
                <h2>
                  CLIQUE NO BOTÃO ABAIXO PARA TIRAR SUAS DÚVIDAS SOBRE O
                  FORMULÁRIO
                </h2>
                <Button
                  type="primary"
                  onClick={() => {
                    window.location.href =
                      "https://www.youtube.com/@focussegurancadotrabalho5442";
                  }}
                  style={{ marginBottom: "15px" }}
                >
                  ASSISTIR VIDEO
                </Button>
                {observation && (
                  <>
                    <h2>
                      {status === "alteracao"
                        ? "MOTIVO DA ALTERAÇÃO SOLICITADA PELO TÉCNICO"
                        : "OBSERVAÇÃO DO FRANQUEADO"}
                    </h2>
                    <h4
                      style={{
                        width: "100%",
                        padding: 15,
                        background:
                          status === "alteracao" ? "#fffbe6" : "#f0f0f0",
                        borderLeft:
                          status === "alteracao" ? "4px solid #FFBB45" : "none",
                        borderRadius:
                          status === "alteracao" ? "0 10px 10px 0" : 10,
                        fontWeight: "bold",
                      }}
                    >
                      {observation}
                    </h4>
                  </>
                )}
                <h2>DADOS DA EMPRESA</h2>
                <div className="inputs">
                  <ViewInput style={{ maxWidth: 540 }}>
                    <p>Razão Social</p>
                    <Input
                      value={razao_social}
                      color="#888"
                      placeholder={"razão socia"}
                      status={errors.razao_social ? "error" : undefined}
                      onChange={(text) => {
                        setRazao_social(text.target.value);
                        if (errors.razao_social) {
                          setErrors((prev) => ({
                            ...prev,
                            razao_social: false,
                          }));
                        }
                      }}
                    />
                  </ViewInput>
                  <ViewInput style={{ maxWidth: 540 }}>
                    <p>Nome Fantasia</p>
                    <Input
                      value={nome_fantasia}
                      color="#888"
                      placeholder={"nome fantasia"}
                      onChange={(text) => {
                        setNome_Fantasia(text.target.value);
                      }}
                    />
                  </ViewInput>
                  <ViewInput style={{ maxWidth: 250 }}>
                    <p>Selecione o tipo de documento</p>
                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                        marginTop: "5px",
                      }}
                    >
                      <Button
                        type={type === "CNPJ" ? "primary" : "default"}
                        onClick={() => {
                          setType("CNPJ");
                          setCnpj("");
                        }}
                        style={{ borderRadius: "50px", flex: 1 }}
                      >
                        CNPJ
                      </Button>
                      <Button
                        type={type === "CAEPF" ? "primary" : "default"}
                        onClick={() => {
                          setType("CAEPF");
                          setCnpj("");
                        }}
                        style={{ borderRadius: "50px", flex: 1 }}
                      >
                        CAEPF
                      </Button>
                    </div>
                  </ViewInput>
                  <ViewInput style={{ maxWidth: 250 }}>
                    <p>{type}</p>
                    <InputMask
                      mask={
                        type === "CNPJ"
                          ? "99.999.999/9999-99"
                          : "999.999.999/999-99"
                      }
                      maskChar={null}
                      value={cnpj}
                      onChange={(text) => {
                        console.log(cnpj);
                        setCnpj(text.target.value);
                        if (errors.cnpj) {
                          setErrors((prev) => ({ ...prev, cnpj: false }));
                        }
                      }}
                    >
                      {(inputProps) =>
                        type === "CNPJ" ? (
                          <Input.Search
                            {...inputProps}
                            color="#888"
                            placeholder={"cnpj"}
                            status={errors.cnpj ? "error" : undefined}
                            onSearch={lookupCNPJ}
                            enterButton
                            loading={isLoadingIA == "CNPJ"}
                          />
                        ) : (
                          <Input
                            {...inputProps}
                            color="#888"
                            placeholder={"caepf"}
                            status={errors.cnpj ? "error" : undefined}
                          />
                        )
                      }
                    </InputMask>
                  </ViewInput>
                  <ViewInput style={{ maxWidth: 370 }}>
                    <p>Ramo de Atividade</p>
                    <Input
                      value={ramo_atividade}
                      color="#888"
                      placeholder={"ramo de Atividade"}
                      status={errors.ramo_atividade ? "error" : undefined}
                      onChange={(text) => {
                        setRamo_atividade(text.target.value);
                        if (errors.ramo_atividade) {
                          setErrors((prev) => ({
                            ...prev,
                            ramo_atividade: false,
                          }));
                        }
                      }}
                    />
                  </ViewInput>
                  <ViewInput style={{ maxWidth: 150 }}>
                    <p>CEP</p>
                    <InputMask
                      mask="99999-999"
                      maskChar={null}
                      value={cep}
                      onChange={(text) => {
                        setCep(text.target.value.replace(/\D/g, ""));
                        if (errors.cep) {
                          setErrors((prev) => ({ ...prev, cep: false }));
                        }
                      }}
                    >
                      {(inputProps) => (
                        <Input
                          {...inputProps}
                          color="#888"
                          placeholder={"cep"}
                          status={errors.cep ? "error" : undefined}
                        />
                      )}
                    </InputMask>
                  </ViewInput>
                  <ViewInput>
                    <p>Endereço</p>
                    <Input.TextArea
                      value={endereco}
                      color="#888"
                      placeholder={"endereço da empresa"}
                      status={errors.endereco ? "error" : undefined}
                      onChange={(text) => {
                        setEndereco(text.target.value);
                        if (errors.endereco) {
                          setErrors((prev) => ({ ...prev, endereco: false }));
                        }
                      }}
                    />
                  </ViewInput>

                  <h2>DADOS RESPONSÁVEL</h2>
                  <ViewInput style={{ maxWidth: 400 }}>
                    <p>Nome do Responsável Assinante</p>
                    <Input
                      value={nome_responsavel}
                      color="#888"
                      placeholder={"nome do responsável"}
                      status={errors.nome_responsavel ? "error" : undefined}
                      onChange={(text) => {
                        setNome_responsavel(text.target.value);
                        if (errors.nome_responsavel) {
                          setErrors((prev) => ({
                            ...prev,
                            nome_responsavel: false,
                          }));
                        }
                      }}
                    />
                  </ViewInput>
                  <ViewInput style={{ maxWidth: 400 }}>
                    <p>CPF do Responsável</p>
                    <InputMask
                      mask="999.999.999-99"
                      maskChar={null}
                      value={cpf_responsavel}
                      onChange={(text) => {
                        setCpf_responsavel(text.target.value);
                        if (errors.cpf_responsavel) {
                          setErrors((prev) => ({
                            ...prev,
                            cpf_responsavel: false,
                          }));
                        }
                      }}
                    >
                      {(inputProps) => (
                        <Input
                          {...inputProps}
                          color="#888"
                          placeholder={"cpf do responsável"}
                          status={errors.cpf_responsavel ? "error" : undefined}
                        />
                      )}
                    </InputMask>
                  </ViewInput>
                  <ViewInput style={{ maxWidth: 240 }}>
                    <p>Contato do Responsável</p>
                    <InputMask
                      mask={(() => {
                        const cleanPhone = contato_responsavel.replace(
                          /\D/g,
                          "",
                        );
                        const isCelular =
                          cleanPhone.length > 10 ||
                          (cleanPhone.length > 2 && cleanPhone[2] === "9");
                        return isCelular ? "(99) 99999-9999" : "(99) 9999-9999";
                      })()}
                      maskChar={null}
                      value={contato_responsavel}
                      onChange={(text) => {
                        setContato_responsavel(
                          text.target.value.replace(/\D/g, ""),
                        );
                        if (errors.contato_responsavel) {
                          setErrors((prev) => ({
                            ...prev,
                            contato_responsavel: false,
                          }));
                        }
                      }}
                    >
                      {(inputProps) => (
                        <Input
                          {...inputProps}
                          color="#888"
                          placeholder={"(99) 99999-9999"}
                          status={
                            errors.contato_responsavel ? "error" : undefined
                          }
                        />
                      )}
                    </InputMask>
                  </ViewInput>
                </div>

                <h2 style={{ marginBottom: 0 }}>
                  QUADRO DE LEVANTAMENTO DE RISCOS OCUPACIONAIS{" "}
                </h2>
                <div className="inputs">
                  {companySector.map((item, index) => {
                    return (
                      <Setor
                        key={index}
                        style={{
                          borderBottomWidth:
                            index + 1 == companySector.length ? 0 : 2,
                        }}
                      >
                        <h3
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: 10,
                            width: "100%",
                          }}
                        >
                          Setor {index + 1}
                          {companySector.length > 1 && (
                            <Button
                              type="primary"
                              className="delete-button"
                              onClick={() => {
                                confirm({
                                  okText: "Confirmar",
                                  title: "Deseja excluir esse setor?",
                                  icon: <ExclamationCircleFilled />,
                                  content: `Após essa ação, o setor ${
                                    index + 1
                                  } e todos os seus dados serão excluidos.`,
                                  onOk() {
                                    deleteSetor(index);
                                  },
                                  onCancel() {},
                                  cancelText: "Cancelar",
                                });
                              }}
                              style={{
                                width: 28,
                                height: 28,
                                marginLeft: 8,
                                borderRadius: 6,
                                padding: 0,
                              }}
                            >
                              <MdDelete color="#fff" size={18} />
                            </Button>
                          )}
                        </h3>

                        <ViewInput style={{ maxWidth: "540px" }}>
                          <p>Nome do setor</p>
                          <Input
                            value={item.name}
                            color="#888"
                            placeholder={"nome do setor"}
                            disabled={!!item.sgg_id}
                            status={
                              errors.sectors?.[index]?.name
                                ? "error"
                                : undefined
                            }
                            onChange={(text) => {
                              let companySectorC = [...companySector];
                              companySectorC[index].name = text.target.value;
                              setCompanySector(companySectorC);
                            }}
                          />
                        </ViewInput>
                        <ViewInput style={{ maxWidth: "540px" }}>
                          <p>Descrição do ambiente</p>
                          <Input.TextArea
                            value={item.description}
                            color="#888"
                            placeholder={"descrição do ambiente"}
                            disabled={!!item.sgg_id}
                            status={
                              errors.sectors?.[index]?.description
                                ? "error"
                                : undefined
                            }
                            onChange={(text) => {
                              let companySectorC = [...companySector];
                              companySectorC[index].description =
                                text.target.value;
                              setCompanySector(companySectorC);
                            }}
                          />
                        </ViewInput>

                        <h2>IMAGENS DO SETOR (máx 5)</h2>
                        <Images>
                          {companyImages[index].length <= 4 && (
                            <Image style={{ position: "relative" }}>
                              <Button
                                type="primary"
                                style={{
                                  display: "flex",
                                  margin: "auto",
                                  borderRadius: 6,
                                }}
                              >
                                <MdAdd color="#fff" size={24} />
                                Nova Imagem
                              </Button>
                              <input
                                id="avatar"
                                style={{
                                  cursor: "pointer",
                                  position: "absolute",
                                  width: "100%",
                                  height: "100%",
                                  opacity: 0,
                                }}
                                multiple={false}
                                type="file"
                                accept="image/"
                                onChange={async (file) => {
                                  let [filesUp] = Object.values(
                                    file.target.files,
                                  );
                                  const data = new FormData();
                                  data.append("index", index);
                                  data.append("file", filesUp, filesUp.name);
                                  await api
                                    .post(`/company-image/${id}`, data)
                                    .then(async (response) => {
                                      let companyImagesC = [...companyImages];
                                      companyImagesC[index].push(response.data);
                                      setCompanyImages(companyImagesC);
                                      toast.success(
                                        `Imagem foi enviada com sucesso`,
                                      );
                                    })
                                    .catch(({ response }) => {
                                      if (response) {
                                        if (response.data) {
                                          if (response.data.message) {
                                            toast.warn(response.data.message);
                                          } else {
                                            toast.error(
                                              "Erro Interno. verifique sua conexão e tente novamente",
                                            );
                                          }
                                        } else {
                                          toast.error(
                                            "Erro Interno. verifique sua conexão e tente novamente",
                                          );
                                        }
                                      } else {
                                        toast.error(
                                          "Erro Interno. verifique sua conexão e tente novamente",
                                        );
                                      }
                                    });
                                }}
                              />
                            </Image>
                          )}
                          {companyImages[index].map((item) => {
                            return (
                              <Image>
                                <img src={item.photo_url} />
                                <Button
                                  className="delete-button"
                                  onClick={async () => {
                                    await api
                                      .delete(`/company-image/${item.id}`)
                                      .then(async () => {
                                        let companyImagesC = [...companyImages];
                                        companyImagesC[index] = companyImagesC[
                                          index
                                        ].filter((data) => {
                                          return item.id != data.id;
                                        });
                                        setCompanyImages(companyImagesC);
                                        toast.success(
                                          `Imagem foi deletada com sucesso`,
                                        );
                                      })
                                      .catch(({ response }) => {
                                        if (response) {
                                          if (response.data) {
                                            if (response.data.message) {
                                              toast.warn(response.data.message);
                                            } else {
                                              toast.error(
                                                "Erro Interno. verifique sua conexão e tente novamente",
                                              );
                                            }
                                          } else {
                                            toast.error(
                                              "Erro Interno. verifique sua conexão e tente novamente",
                                            );
                                          }
                                        } else {
                                          toast.error(
                                            "Erro Interno. verifique sua conexão e tente novamente",
                                          );
                                        }
                                      });
                                  }}
                                  style={{
                                    width: 30,
                                    height: 30,
                                    marginBottom: 10,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    marginTop: 10,
                                    padding: 0,
                                    borderRadius: 6,
                                  }}
                                >
                                  <MdDelete color="#fff" size={20} />
                                </Button>
                              </Image>
                            );
                          })}
                        </Images>
                        <h2>FUNÇÕES DO SETOR</h2>
                        {item.companyEmployees.map((data, i) => {
                          return (
                            <>
                              <h3
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginTop: 10,
                                  width: "100%",
                                }}
                              >
                                Função {i + 1}
                                {item.companyEmployees.length > 1 && (
                                  <Button
                                    type="primary"
                                    className="delete-button"
                                    onClick={() => {
                                      confirm({
                                        okText: "Confirmar",
                                        title: "Deseja excluir essa função?",
                                        icon: <ExclamationCircleFilled />,
                                        content: `Após essa ação, a função ${
                                          i + 1
                                        } será excluida.`,
                                        onOk() {
                                          deleteFuncao(index, i);
                                        },
                                        onCancel() {},
                                        cancelText: "Cancelar",
                                      });
                                    }}
                                    style={{
                                      width: 28,
                                      height: 28,
                                      marginLeft: 8,
                                      borderRadius: 6,
                                      padding: 0,
                                    }}
                                  >
                                    <MdDelete color="#fff" size={18} />
                                  </Button>
                                )}
                              </h3>
                              <ViewInput style={{ maxWidth: "400px" }}>
                                <p>Função</p>
                                <Input.Search
                                  type="primary"
                                  enterButton
                                  loading={isLoadingIA == `S${index}F${i}`}
                                  disabled={
                                    !!data.sgg_id ||
                                    (isLoadingIA &&
                                      isLoadingIA != `S${index}F${i}`)
                                  }
                                  value={data.name}
                                  color="#888"
                                  onSearch={() => {
                                    getOccupation(index, i, data.name);
                                  }}
                                  placeholder={"funcao"}
                                  status={
                                    errors.sectors?.[index]?.employees?.[i]
                                      ?.name
                                      ? "error"
                                      : undefined
                                  }
                                  onChange={(text) => {
                                    let companySectorC = [...companySector];
                                    companySectorC[index].companyEmployees[
                                      i
                                    ].name = text.target.value;
                                    setCompanySector(companySectorC);
                                  }}
                                />
                              </ViewInput>
                              <ViewInput style={{ maxWidth: "120px" }}>
                                <p>CBO</p>
                                <InputMask
                                  disabled={!!data.sgg_id}
                                  mask="9999-99"
                                  maskChar={null}
                                  value={data.cbo}
                                  onChange={(text) => {
                                    let companySectorC = [...companySector];
                                    companySectorC[index].companyEmployees[
                                      i
                                    ].cbo = text.target.value.replace(
                                      /\D/g,
                                      "",
                                    );
                                    setCompanySector(companySectorC);
                                  }}
                                >
                                  {(inputProps) => (
                                    <Input
                                      {...inputProps}
                                      color="#888"
                                      placeholder={"cbo"}
                                      disabled={!!data.sgg_id}
                                      status={
                                        errors.sectors?.[index]?.employees?.[i]
                                          ?.cbo
                                          ? "error"
                                          : undefined
                                      }
                                    />
                                  )}
                                </InputMask>
                              </ViewInput>
                              <ViewInput style={{ maxWidth: "160px" }}>
                                <p>Colaboradores</p>
                                <Input
                                  prefix="QTD"
                                  type="number"
                                  value={data.quantidade_colaboradores}
                                  color="#888"
                                  placeholder={"0"}
                                  status={
                                    errors.sectors?.[index]?.employees?.[i]
                                      ?.quantidade_colaboradores
                                      ? "error"
                                      : undefined
                                  }
                                  onChange={(text) => {
                                    let companySectorC = [...companySector];
                                    if (parseInt(text.target.value) > 0) {
                                      companySectorC[index].companyEmployees[
                                        i
                                      ].quantidade_colaboradores =
                                        parseInt(text.target.value) || "";
                                      companySectorC[index].companyEmployees[
                                        i
                                      ].quantidade_colaboradores_f =
                                        parseInt(text.target.value) || "";
                                      companySectorC[index].companyEmployees[
                                        i
                                      ].quantidade_colaboradores_m = "";
                                    } else {
                                      companySectorC[index].companyEmployees[
                                        i
                                      ].quantidade_colaboradores = "";
                                      companySectorC[index].companyEmployees[
                                        i
                                      ].quantidade_colaboradores_f = "";
                                      companySectorC[index].companyEmployees[
                                        i
                                      ].quantidade_colaboradores_m = "";
                                    }
                                    setCompanySector(companySectorC);
                                  }}
                                />
                              </ViewInput>
                              <ViewInput style={{ maxWidth: "150px" }}>
                                <p>Masculino</p>
                                <Input
                                  prefix="QTD"
                                  type="number"
                                  value={data.quantidade_colaboradores_m}
                                  color="#888"
                                  placeholder={"0"}
                                  onChange={(text) => {
                                    let companySectorC = [...companySector];
                                    if (
                                      parseInt(text.target.value) >
                                      (parseInt(
                                        companySectorC[index].companyEmployees[
                                          i
                                        ].quantidade_colaboradores,
                                      ) || 0)
                                    ) {
                                      toast.warn(
                                        "Número de colaboradores masculinos é maior que o total de colaboradores",
                                      );
                                    } else {
                                      companySectorC[index].companyEmployees[
                                        i
                                      ].quantidade_colaboradores_m = text.target
                                        .value
                                        ? parseInt(text.target.value)
                                        : "";
                                      companySectorC[index].companyEmployees[
                                        i
                                      ].quantidade_colaboradores_f = text.target
                                        .value
                                        ? companySectorC[index]
                                            .companyEmployees[i]
                                            .quantidade_colaboradores -
                                          parseInt(text.target.value)
                                        : companySectorC[index]
                                            .companyEmployees[i]
                                            .quantidade_colaboradores;
                                      setCompanySector(companySectorC);
                                    }
                                  }}
                                />
                              </ViewInput>
                              <ViewInput style={{ maxWidth: "150px" }}>
                                <p>Feminino</p>
                                <Input
                                  prefix="QTD"
                                  value={data.quantidade_colaboradores_f}
                                  color="#888"
                                  disabled
                                />
                              </ViewInput>

                              <ViewInput style={{ maxWidth: "540px" }}>
                                <p>Descrição das Atividades</p>
                                <Input.TextArea
                                  value={data.description}
                                  color="#888"
                                  placeholder={"descrição"}
                                  disabled={!!data.sgg_id}
                                  status={
                                    errors.sectors?.[index]?.employees?.[i]
                                      ?.description
                                      ? "error"
                                      : undefined
                                  }
                                  onChange={(text) => {
                                    let companySectorC = [...companySector];
                                    companySectorC[index].companyEmployees[
                                      i
                                    ].description = text.target.value;
                                    setCompanySector(companySectorC);
                                  }}
                                />
                              </ViewInput>

                              <ViewInput
                                style={{ maxWidth: "540px", marginBottom: 20 }}
                              >
                                <p>EPIS usados na função</p>
                                <Input.TextArea
                                  value={data.epis}
                                  color="#888"
                                  placeholder={"epis"}
                                  disabled={!!data.sgg_id}
                                  status={
                                    errors.sectors?.[index]?.employees?.[i]
                                      ?.epis
                                      ? "error"
                                      : undefined
                                  }
                                  onChange={(text) => {
                                    let companySectorC = [...companySector];
                                    companySectorC[index].companyEmployees[
                                      i
                                    ].epis = text.target.value;
                                    setCompanySector(companySectorC);
                                  }}
                                />
                              </ViewInput>
                              {item.companyEmployees.length != i + 1 && <hr />}
                            </>
                          );
                        })}
                        <Button
                          type="primary"
                          onClick={() => {
                            let companySectorC = [...companySector];
                            let companyImagesC = [...companyImages];
                            companyImagesC.push([]);
                            companySectorC[index].companyEmployees.push({
                              name: "",
                              id: "",
                              epis: "",
                              quantidade_colaboradores: 0,
                              description: "",
                              quantidade_colaboradores_m: 0,
                              quantidade_colaboradores_f: 0,
                              cbo: "",
                            });
                            setCompanyImages(companyImagesC);
                            setCompanySector(companySectorC);
                          }}
                          style={{
                            marginTop: 15,
                            marginBottom: 15,
                            display: "flex",
                          }}
                        >
                          <MdAdd color="#fff" size={24} />
                          Nova Função
                        </Button>
                        <h2>RISCOS DO SETOR</h2>
                        <div style={{ display: "flex" }}>
                          <Button
                            type="primary"
                            disabled={!!item.sgg_risks_id}
                            onClick={() => {
                              setVisibleModalRisk(true);
                              setId_risk(-1);
                              setId_sector(index);
                              setName_risk("");
                              setDescription_risk("");
                              setType_risk("");
                              setEpcs("");
                              setEpis("");
                              setTempo_exposicao("");
                              setTipo_exposicao("");
                              setMedidas_controle("");
                              setPerigos("");
                              setProbabilidade("");
                              setEfeito("");
                              setFonte_geradora("");
                            }}
                            style={{
                              marginTop: 15,
                              marginBottom: 15,
                              display: "flex",
                              marginRight: 15,
                            }}
                          >
                            <MdAdd color="#fff" size={24} />
                            Novo Risco
                          </Button>

                          <Button
                            type="primary"
                            loading={isLoadingIA == `S${index}`}
                            disabled={
                              !!item.sgg_risks_id ||
                              (isLoadingIA && isLoadingIA != `S${index}`)
                            }
                            onClick={() => {
                              getRisks(index);
                            }}
                            style={{
                              marginTop: 15,
                              marginBottom: 15,
                              display: "flex",
                              marginRight: 15,
                            }}
                          >
                            <MdSearch color="#fff" size={24} />
                            Buscar Riscos
                          </Button>
                          <Button
                            type="primary"
                            loading={isLoadingIA == `SI${index}`}
                            disabled={
                              !!item.sgg_risks_id ||
                              (isLoadingIA && isLoadingIA != `SI${index}`)
                            }
                            onClick={() => {
                              getRisksImages(index);
                            }}
                            style={{
                              marginTop: 15,
                              marginBottom: 15,
                              display: "flex",
                            }}
                          >
                            <MdSearch color="#fff" size={24} />
                            Buscar Riscos pelas Images
                          </Button>
                        </div>
                        <Risks>
                          {!item.companyScratchs?.length && (
                            <Message>
                              Nenhum risco cadastrado até o momento
                            </Message>
                          )}
                          {item.companyScratchs.map((risk, riskIndex) => {
                            return (
                              <RiskItem
                                key={riskIndex}
                                hasError={
                                  !!errors.sectors?.[index]?.scratchs?.[
                                    riskIndex
                                  ]
                                }
                              >
                                <div className="risk-info">
                                  <p>
                                    <strong>
                                      Risco {risk.type} - {risk.name}
                                    </strong>
                                  </p>
                                  <p>
                                    <strong>Atividades/Processos:</strong>{" "}
                                    {risk.description}
                                  </p>
                                  <p>
                                    <strong>Fonte Geradora:</strong>{" "}
                                    {risk.fonte_geradora}
                                  </p>
                                  <p>
                                    <strong>Perigos:</strong> {risk.perigos}
                                  </p>
                                  <p>
                                    <strong>Avaliação de Risco:</strong> (
                                    {risk.probabilidade} x {risk.efeito})
                                  </p>
                                  <p>
                                    <strong>EPIs:</strong> {risk.epis}
                                  </p>
                                  <p>
                                    <strong>EPCs:</strong> {risk.epcs}
                                  </p>
                                  <p>
                                    <strong>Medidas de Controle:</strong>{" "}
                                    {risk.medidas_controle}
                                  </p>
                                  <p>
                                    <strong>Tipo de Exposição:</strong>{" "}
                                    {risk.tipo_exposicao}
                                  </p>
                                  <p>
                                    <strong>Tempo de Exposição:</strong>{" "}
                                    {risk.tempo_exposicao}
                                  </p>
                                </div>
                                <div className="risk-actions">
                                  <Button
                                    type="primary"
                                    disabled={!!item.sgg_risks_id}
                                    onClick={() => {
                                      setId_sector(index);
                                      setId_risk(riskIndex);
                                      setName_risk(risk.name);
                                      setDescription_risk(risk.description);
                                      setType_risk(risk.type);
                                      setEpcs(risk.epcs);
                                      setEpis(risk.epis);
                                      setMedidas_controle(
                                        risk.medidas_controle,
                                      );
                                      setTipo_exposicao(risk.tipo_exposicao);
                                      setTempo_exposicao(risk.tempo_exposicao);
                                      setPerigos(risk.perigos);
                                      setProbabilidade(risk.probabilidade);
                                      setEfeito(risk.efeito);
                                      setFonte_geradora(risk.fonte_geradora);
                                      setVisibleModalRisk(true);
                                    }}
                                  >
                                    <MdEdit />
                                    Editar
                                  </Button>
                                  <Button
                                    className="delete-button"
                                    disabled={!!item.sgg_risks_id}
                                    onClick={() => {
                                      confirm({
                                        okText: "Confirmar",
                                        title: "Deseja excluir esse risco?",
                                        icon: <ExclamationCircleFilled />,
                                        content: `Após essa ação, a o risco ${risk.type} - ${risk.name} será excluido.`,
                                        onOk() {
                                          let companySectorC = [
                                            ...companySector,
                                          ];
                                          companySectorC[
                                            index
                                          ].companyScratchs = companySectorC[
                                            index
                                          ].companyScratchs.filter(
                                            (item, idx) => idx != riskIndex,
                                          );
                                          setCompanySector(companySectorC);
                                        },
                                        onCancel() {},
                                        cancelText: "Cancelar",
                                      });
                                    }}
                                  >
                                    <MdDelete />
                                    Excluir
                                  </Button>
                                </div>
                              </RiskItem>
                            );
                          })}
                        </Risks>
                      </Setor>
                    );
                  })}
                </div>
                <h2
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginTop: 15,
                    width: "100%",
                    justifyContent: "flex-end",
                  }}
                >
                  <Button
                    type="primary"
                    onClick={() => {
                      let companySectorC = [...companySector];
                      let companyImagesC = [...companyImages];
                      companySectorC.push({
                        name: "",
                        description: "",
                        companyScratchs: [],
                        companyEmployees: [
                          {
                            name: "",
                            id: "",
                            epis: "",
                            quantidade_colaboradores: 0,
                            description: "",
                            quantidade_colaboradores_m: 0,
                            quantidade_colaboradores_f: 0,
                            cbo: "",
                          },
                        ],
                      });
                      companyImagesC.push([]);
                      setCompanyImages(companyImagesC);
                      setCompanySector(companySectorC);
                    }}
                  >
                    <MdAdd color="#fff" size={24} />
                    Novo Setor
                  </Button>
                </h2>

                <div
                  style={{
                    background: "#ffffff",
                    border: "1px solid #e0e0e0",
                    borderRadius: "12px",
                    padding: "20px 24px",
                    margin: "35px 0",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexWrap: "wrap",
                    gap: "20px",
                    width: "100%",
                    boxSizing: "border-box",
                  }}
                >
                  <div style={{ flex: 1, minWidth: "250px" }}>
                    <span
                      style={{
                        fontSize: "18px",
                        fontWeight: "bold",
                        color: "#333",
                        display: "block",
                      }}
                    >
                      Resumo do Quadro de Funcionários
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      minWidth: "220px",
                      width: "100%",
                      maxWidth: "300px",
                    }}
                  >
                    <span
                      style={{
                        background: "#e8f5e9",
                        color: "#2e7d32",
                        padding: "8px 16px",
                        borderRadius: "8px",
                        fontSize: "14px",
                        fontWeight: "bold",
                        border: "1px solid #c8e6c9",
                        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.02)",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: "20px",
                      }}
                    >
                      <span>Total:</span>
                      <strong>{total}</strong>
                    </span>
                    <span
                      style={{
                        background: "#e3f2fd",
                        color: "#1565c0",
                        padding: "8px 16px",
                        borderRadius: "8px",
                        fontSize: "14px",
                        fontWeight: "bold",
                        border: "1px solid #bbdefb",
                        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.02)",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: "20px",
                      }}
                    >
                      <span>Masculinos:</span>
                      <strong>{totalM}</strong>
                    </span>
                    <span
                      style={{
                        background: "#fce4ec",
                        color: "#c2185b",
                        padding: "8px 16px",
                        borderRadius: "8px",
                        fontSize: "14px",
                        fontWeight: "bold",
                        border: "1px solid #f8bbd0",
                        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.02)",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: "20px",
                      }}
                    >
                      <span>Femininos:</span>
                      <strong>{total - totalM || 0}</strong>
                    </span>
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "center",
                    margin: "35px 0",
                  }}
                >
                  <Button
                    type="primary"
                    title={"Salvar"}
                    style={{
                      margin: "0 10px",
                      height: 45,
                      fontSize: 18,
                      width: "100%",
                      maxWidth: 350,
                    }}
                    onClick={() => {
                      verifyCompany(false);
                    }}
                  >
                    Salvar
                  </Button>
                  {user && user.id == company.collaborador_id && (
                    <Button
                      type="primary"
                      title={"Salvar e Assinar"}
                      style={{
                        margin: "0 10px",
                        height: 45,
                        fontSize: 18,
                        width: "100%",
                        maxWidth: 350,
                        opacity: hasUnsavedChanges ? 0.5 : 1,
                      }}
                      onClick={() => {
                        if (hasUnsavedChanges) {
                          toast.warn(
                            "Você possui alterações não salvas. Por favor, salve o formulário antes de finalizar.",
                          );
                          return;
                        }
                        confirm({
                          okText: "Confirmar",
                          title: "Deseja finalizar o formulário?",
                          icon: <ExclamationCircleFilled />,
                          content: `Após finalizar o formulário, não será possível fazer novas alterações.`,
                          onOk() {
                            verifyCompany(true);
                          },
                          onCancel() {},
                          cancelText: "Cancelar",
                        });
                      }}
                    >
                      Finalizar Formulário
                    </Button>
                  )}
                </div>
              </>
            )}
          </>
        )}
        <Modal
          title={id_risk != -1 ? "Editar Risco" : "Cadastrar Risco"}
          width={500}
          centered
          className="modal-risk-scroll"
          styles={{
            body: {
              maxHeight: "70vh",
              overflowY: "auto",
            },
          }}
          confirmLoading={isLoadingModal}
          open={visibleModalRisk}
          okText={"SALVAR"}
          cancelText="FECHAR"
          onOk={() => {
            if (
              !name_risk ||
              !type_risk ||
              !description_risk ||
              !fonte_geradora ||
              !perigos ||
              !probabilidade ||
              !efeito ||
              !epis ||
              !epcs ||
              !tipo_exposicao ||
              !tempo_exposicao
            ) {
              toast.warn("Preencha todos os campos obrigatórios");
              return;
            }

            let companySectorC = [...companySector];
            const saveRisk = {
              name: name_risk,
              type: type_risk,
              description: description_risk,
              fonte_geradora: fonte_geradora,
              perigos: perigos,
              efeito: efeito,
              probabilidade: probabilidade,
              epis: epis,
              epcs: epcs,
              medidas_controle: medidas_controle,
              tempo_exposicao: tempo_exposicao,
              tipo_exposicao: tipo_exposicao,
            };
            if (id_risk != -1) {
              companySectorC[id_sector].companyScratchs[id_risk] = saveRisk;
            } else {
              companySectorC[id_sector].companyScratchs.push(saveRisk);
            }
            setCompanySector(companySectorC);
            setVisibleModalRisk(false);
          }}
          onCancel={() => {
            if (isLoadingIA == `R`) {
              toast.warn("Aguarde a finalização da busca para fechar modal");
            } else {
              setVisibleModalRisk(false);
            }
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: "0 12px 0 0",
            }}
          >
            <ViewInput>
              <p>Tipo*</p>
              <Select
                placeholder="selecionar tipo do risco"
                value={type_risk || null}
                disabled={isLoadingIA == `R`}
                style={{ width: "100%", textAlign: "left" }}
                onChange={(value) => {
                  setType_risk(value);
                  setName_risk("");
                }}
              >
                <Select.Option value="Físico">Físico</Select.Option>
                <Select.Option value="Químico">Químico</Select.Option>
                <Select.Option value="Biológico">Biológico</Select.Option>
                <Select.Option value="Ergonômico">Ergonômico</Select.Option>
                <Select.Option value="Acidentes">Acidentes</Select.Option>
                <Select.Option value="Não Especificado">
                  Não Especificado
                </Select.Option>
              </Select>
            </ViewInput>
            <ViewInput>
              <p>Nome*</p>
              <div style={{ display: "flex", width: "100%" }}>
                <Select
                  showSearch
                  disabled={!type_risk}
                  options={optionsRisks}
                  filterOption={(inputValue, option) => {
                    const normalizedInput = inputValue
                      .normalize("NFD")
                      .replace(/[\u0300-\u036f]/g, "")
                      .toUpperCase();
                    const normalizedOption = (
                      option?.label ||
                      option?.value ||
                      ""
                    )
                      .normalize("NFD")
                      .replace(/[\u0300-\u036f]/g, "")
                      .toUpperCase();
                    return normalizedOption.indexOf(normalizedInput) !== -1;
                  }}
                  style={{
                    width: "100%",
                    flex: 1,
                    minWidth: 0,
                    textAlign: "left",
                  }}
                  placeholder="nome do risco"
                  value={name_risk || undefined}
                  onChange={(value) => setName_risk(value)}
                />
                <Button
                  type="primary"
                  style={{ marginLeft: 5 }}
                  loading={isLoadingIA == `R`}
                  disabled={isLoadingIA && isLoadingIA != `R`}
                  onClick={() => {
                    getRisk(type_risk, name_risk, id_sector);
                  }}
                >
                  <MdSearch size={20} />
                </Button>
              </div>
            </ViewInput>
            <ViewInput>
              <p>Atividades/Processos*</p>
              <Input.TextArea
                style={{ minHeight: 40 }}
                placeholder="atividades/processos"
                value={description_risk}
                onChange={(event) => setDescription_risk(event.target.value)}
              />
            </ViewInput>
            <ViewInput>
              <p>Fonte Geradora</p>
              <Input.TextArea
                style={{ minHeight: 40 }}
                placeholder="fonte geradora"
                value={fonte_geradora}
                onChange={(event) => setFonte_geradora(event.target.value)}
              />
            </ViewInput>
            <ViewInput>
              <p>Perigos (Atividade e Processo)</p>
              <Input.TextArea
                style={{ minHeight: 40 }}
                placeholder="perigos"
                value={perigos}
                onChange={(event) => setPerigos(event.target.value)}
              />
            </ViewInput>
            <ViewInput>
              <p>Avaliação do Risco (Probabilidade)</p>
              <Select
                placeholder="Probabilidade"
                value={probabilidade || null}
                onChange={(v) => setProbabilidade(v)}
                style={{ width: "100%" }}
              >
                <Select.Option value="Não há exposição">
                  Não há exposição
                </Select.Option>
                <Select.Option value="Exposição a níveis baixos">
                  Exposição a níveis baixos
                </Select.Option>
                <Select.Option value="Exposição moderada">
                  Exposição moderada
                </Select.Option>
                <Select.Option value="Exposição elevada">
                  Exposição elevada
                </Select.Option>
                <Select.Option value="Exposição elevadíssima">
                  Exposição elevadíssima
                </Select.Option>
              </Select>
            </ViewInput>
            <ViewInput>
              <p>Avaliação do Risco (Efeito)</p>
              <Select
                placeholder="Efeito"
                value={efeito || null}
                onChange={(v) => setEfeito(v)}
                style={{ width: "100%" }}
              >
                <Select.Option value="Pouca importância">
                  Pouca importância
                </Select.Option>
                <Select.Option value="Preocupantes">Preocupantes</Select.Option>
                <Select.Option value="Severos">Severos</Select.Option>
                <Select.Option value="Irreversíveis">
                  Irreversíveis
                </Select.Option>
                <Select.Option value="Ameaça">Ameaça</Select.Option>
              </Select>
            </ViewInput>
            <ViewInput>
              <p>EPI(s) Recomendado(s) </p>
              <Input.TextArea
                style={{ minHeight: 40 }}
                placeholder="epis"
                value={epis}
                onChange={(event) => setEpis(event.target.value)}
              />
            </ViewInput>
            <ViewInput>
              <p>EPC(s) Recomendado(s) </p>
              <Input.TextArea
                style={{ minHeight: 40 }}
                placeholder="epcs"
                value={epcs}
                onChange={(event) => setEpcs(event.target.value)}
              />
            </ViewInput>
            <ViewInput>
              <p>Medidas de Controle Adicional</p>
              <Input.TextArea
                style={{ minHeight: 20 }}
                placeholder="medidas de controle"
                value={medidas_controle}
                onChange={(event) => setMedidas_controle(event.target.value)}
              />
            </ViewInput>
            <ViewInput>
              <p>Exposição (Tipo)</p>
              <Select
                placeholder="Tipo"
                value={tipo_exposicao || null}
                onChange={(v) => setTipo_exposicao(v)}
                style={{ width: "100%" }}
              >
                <Select.Option value="Eventual/Ocasional">
                  Eventual/Ocasional
                </Select.Option>
                <Select.Option value="Habitual">Habitual</Select.Option>
                <Select.Option value="Habitual/Intermitente">
                  Habitual/Intermitente
                </Select.Option>
                <Select.Option value="Habitual/Permanente">
                  Habitual/Permanente
                </Select.Option>
                <Select.Option value="Intermitente">Intermitente</Select.Option>
                <Select.Option value="N.A.">N.A.</Select.Option>
                <Select.Option value="Não Habitual/Não Permanente">
                  Não Habitual/Não Permanente
                </Select.Option>
                <Select.Option value="Ocasional">Ocasional</Select.Option>
                <Select.Option value="Ocasional/Intermitente">
                  Ocasional/Intermitente
                </Select.Option>
                <Select.Option value="Ocasional/Permanente">
                  Ocasional/Permanente
                </Select.Option>
                <Select.Option value="Permanente">Permanente</Select.Option>
              </Select>
            </ViewInput>
            <ViewInput>
              <p>Exposição (Tempo)</p>
              <Input
                placeholder="Tempo (ex: 8h)"
                value={tempo_exposicao}
                onChange={(e) => setTempo_exposicao(e.target.value)}
                style={{ width: "100%" }}
              />
            </ViewInput>
          </div>
        </Modal>
        <Modal
          title="Copiar Dados do Formulário"
          width={500}
          centered
          open={copyModalVisible}
          onOk={handleConfirmCopy}
          onCancel={() => setCopyModalVisible(false)}
          okText="CONFIRMAR E COPIAR"
          cancelText="CANCELAR"
          confirmLoading={loading}
        >
          <div style={{ padding: "15px 0" }}>
            <p style={{ marginBottom: 8, fontWeight: "500" }}>
              Selecione o formulário de origem para copiar os dados:
            </p>
            <Select
              showSearch
              placeholder="Digite a razão social, fantasia ou CNPJ..."
              style={{ width: "100%" }}
              filterOption={false}
              loading={loadingCopy}
              onSearch={(value) => loadCompaniesToCopy(value)}
              onChange={(value) => setSelectedCompanyToCopy(value)}
              value={selectedCompanyToCopy}
              notFoundContent={
                loadingCopy ? (
                  <Spin size="small" />
                ) : (
                  "Nenhuma empresa encontrada"
                )
              }
            >
              {companiesToCopy.map((item) => (
                <Select.Option key={item.id} value={item.id}>
                  {item.razao_social || item.nome_fantasia}
                </Select.Option>
              ))}
            </Select>
            <p style={{ marginTop: 15, fontSize: "12px", color: "#8c8c8c" }}>
              * Atenção: A confirmação irá substituir todo o conteúdo preenchido
              nos campos do formulário atual pelos dados da empresa selecionada.
              As imagens não serão copiadas e as imagens do formulário atual serão zeradas.
            </p>
          </div>
        </Modal>
      </Container>
    </div>
  );
}
